import React, { useState } from 'react';
import PortletHeader from '../../../app/components/portlet/PortletHeader';
import AddIcon from '../../../app/components/svgIcons/AddIcon';
import StyledButton from '../../../app/components/styledComponents/StyledButton';
import PortletBody from '../../../app/components/portlet/PortletBody';
import Portlet from '../../../app/components/portlet/Portlet';
import styled, { useTheme } from 'styled-components';
import { StyledLabel } from '../../../assets/styledComponents/Global';
import Table from '../../../app/components/table/Table';
import PaginationPerPage from '../../../app/components/pagination/PaginationPerPage';
import { useDeleteReportMutation, useGetScheduleReportsQuery, useUpdateScheduleReportMutation } from '../reportingApiSlice';
import { LISTING_PER_PAGE } from '../../../config';
import moment from 'moment';
import StyledSwitch from '../../../app/components/styledComponents/StyledSwitch';
import EditIcon from '../../../app/components/svgIcons/EditIcon';
import { Link } from 'react-router-dom';
import DeleteIcon from '../../../app/components/svgIcons/DeleteIcon';
import DeleteDepartmentModal from '../../Setting/Departments/DeleteDepartmentModal';
import { toast } from 'react-toastify';
import StyledToolTip from '../../../app/components/styledComponents/StyledToolTip';
import ExecutionModal from '../components/ExecutionModal';
import LogIcon from '../../../app/components/svgIcons/LogIcon';
import ExecutionIcon from '../../../app/components/svgIcons/ExecutionIcon';
import ReportFailedIcon from '../../../app/components/svgIcons/ReportFailedIcon';
import StyledIconInput from '../../../app/components/styledComponents/StyledIconInput';
import SearchIcon from '../../../app/components/svgIcons/SearchIcon';
import EmptyState from '../../../app/components/nodata/EmptyState';
import TickIcon from '../../../app/components/svgIcons/TickIcon';
import HiringRequestsListingSekeleton from '../../HiringRequests/HiringRequestsListingSekeleton';
import { PERMISSION_DENIED_MESSAGE, PERMISSIONS, usePermissionActionGuard } from '../../../permission-system';

const ReportingDashboard = () => {
const theme = useTheme();
const { runIfAllowed, can } = usePermissionActionGuard();
const canManageReportAnalytics = can(PERMISSIONS.MANAGE_REPORT_ANALYTICS);
const [executionModal,setExecutionModal] = useState(false);

  const initialFilters = {
    perPage: LISTING_PER_PAGE,
    page: 0,
    sortedColumn: { path: 'changed_on_delta_humanized', order: 'desc' },
    query: '',
  };

  const [filters, setFilters] = useState({ ...initialFilters });

  const {
    data: reportingList,
    isFetching,
    refetch
  } = useGetScheduleReportsQuery(
    {
      perPage: filters.perPage,
      page: filters.page,
      query: filters.query && filters.query,
      sort: filters?.sortedColumn?.path || filters.sort,
      sortDir: filters?.sortedColumn?.order.toLowerCase() || filters.sortDir,
    },
    {
      refetchOnMountOrArgChange: true,
    },
  );
  //eslint-disable-next-line
  const [toggle, setIsToggle] = useState(false);


  const [deleteModal, setDeleteModal] = useState(false);
  //eslint-disable-next-line
  const [columns, setColumns] = useState([
     {
            id: 1,
            label: 'State',
            alignBody: 'text-center align-middle ps-3',
            alignHeader: 'text-left align-middle cursor-pointer ps-4',
            content: (report) => (
              <div className="d-flex align-items-center w-fitContent">
                <span className="ms-2">
                  <StyledLabel size='14px' weight='400' font="Fredoka, sans-serif">
                    {' '}
                    <StyledToolTip title={report?.last_state} childrenClass={'ms-0'}>
                    {(report?.last_state === "Success" || report?.last_state === "Not triggered") ? <TickIcon color={theme?.dark ? theme.darkTagGreenTextColor || '#C9F3EF' : theme.green}/>:
                    report?.last_state === 'Error' ? <ReportFailedIcon size={'12'} color={theme.danger}/>:
                     <ExecutionIcon size={40}/>}
                      </StyledToolTip>
                  </StyledLabel>
                </span>
              </div>
            ),
          },
          {
                  id: 2,
                  label: 'Last run',
                  alignBody: 'text-left align-middle',
                  alignHeader: 'text-left align-middle cursor-pointer ps-3',
                  content: (report) => (
                    <div className="d-flex align-items-center w-fitContent">
                      <span className="ms-2">
                        <StyledLabel size='14px' weight='500' font="Raleway, sans-serif">
                          {' '}
                           {report?.last_eval_dttm?.length > 0 ? moment(report?.last_eval_dttm).format('Do MMM YYYY HH:mm') : '--'}
                        </StyledLabel>
                      </span>
                    </div>
                  ),
                },
    {
      id: 3,
      path: 'name',
      isChecked: false,
      label: 'Report Name',
      alignBody: 'align-middle ps-3',
      alignHeader: 'text-left align-middle cursor-pointer ps-4 py-3',
      content: (report) => (
        <div className="d-flex align-items-center w-fitContent">
          <span className="ms-2">
            <StyledLabel size='14px' weight='400' font="Fredoka, sans-serif">
              {' '}
              {report?.name}
            </StyledLabel>
          </span>
        </div>
      ),
    },
    {
      id: 4,
      isChecked: false,
      path: 'crontab_humanized',
      label: 'Schedule',
      alignBody: ' align-middle ',
      alignHeader: 'text-left align-middle cursor-pointer ps-3',
      content: (report) => (
        <div className="d-flex  w-fitContent cursor-pointer">
          <span className="ms-2 cursor-pointer">
            <StyledToolTip
              title={report?.crontab_humanized}
              childrenClass={'ms-0'}
            >

              <StyledLabel size='14px' weight='500' font="Raleway, sans-serif" >
                {' '}
                {report?.crontab_humanized}
              </StyledLabel>
            </StyledToolTip>
          </span>
        </div>
      ),
    },
    {
      id: 6,
      label: 'Created On',
      alignBody: ' align-middle ps-3',
      alignHeader: 'text-left align-middle cursor-pointer ps-4',
      content: (report) => (
        <div className="d-flex align-items-center w-fitContent">
          <span className="ms-2">
            <StyledLabel size='14px' weight='500' font="Raleway, sans-serif" >
              {' '}
               <StyledToolTip title={moment(report?.created_on).format('Do MMM YYYY HH:mm:ss')} childrenClass={'ms-0'}>
              {moment(report?.created_on).format('Do MMM YYYY')}
              </StyledToolTip>
            </StyledLabel>
          </span>
        </div>
      ),
    },
    {
      id: 7,
      isChecked: false,
      path: 'changed_on_delta_humanized',
      label: 'Last Modified',
      alignBody: 'align-middle ps-3',
      alignHeader: 'text-left align-middle cursor-pointer ps-4',
      content: (report) => (
        <div className="d-flex align-items-center w-fitContent">
          <span className="ms-2">
            <StyledLabel size='14px' weight='500' font="Raleway, sans-serif" >
              {' '}
              <StyledToolTip title={moment(report?.changed_on).format('Do MMM YYYY HH:mm:ss')} childrenClass={'ms-0'}>
              {moment(report?.changed_on).format('Do MMM YYYY')}
              </StyledToolTip>
            </StyledLabel>
          </span>
        </div>
      ),
    },
    {
      id: 8,
      isChecked: false,
      path: 'active',
      label: 'Active',
      alignBody: ' text-center align-middle ps-3',
      alignHeader: 'text-left align-middle cursor-pointer ps-3 ',
      content: (report) => (
        <div className="d-flex align-items-center w-fitContent">
          <span className="ms-2">
            {' '}
            <StyledSwitch
              isToggle={report?.active}
              onToggle={() => handleSwitch(!report?.active, report?.id)}
              color={theme.secondary}
              width={'18px'}
              height={'17px'}
              lblheight={'19px'}
              lblWidth={'35px'}
              left={'1px'}
              bottom={'0.3px'}
              top={'1px'}
              disabled={!canManageReportAnalytics}
            />
          </span>
        </div>
      ),
    },
    {
      id: 9,
      label: 'Actions',
      alignBody: 'text-left align-middle ps-3',
      alignHeader: 'text-center align-middle cursor-pointer ps-3',
      content: (report) => (
        <div className="d-flex align-items-center justify-content-center gap-2 ms-3 p-2">
           <Link
                     variant="text"
                     className="text-decoration-none text-actionIcons d-inline-flex"
                     to={``}
                     onClick={()=>{
                    setExecutionModal(report);
                   }}
                   > <LogIcon size="18" /></Link> 
          {canManageReportAnalytics && (
          <Link
            variant="text"
            className="text-decoration-none "
            to={`creation/${report?.id || ''}`}
          >
            <EditIcon size="18" className="me-1 text-actionIcons" />
          </Link>
          )}

          {canManageReportAnalytics && (
          <DeleteIcon className='text-actionIcons cursor-pointer'  onClick={() => {
            runIfAllowed(PERMISSIONS.MANAGE_REPORT_ANALYTICS, () => {
              setDeleteModal(report);
            });
          }} />
          )}
        </div>
      ),
    }
  ]);
  const handlePerPageChange = (perPage) => {
    setFilters((prevState) => ({
      ...prevState,
      perPage: perPage.target.innerText,
      page: 0,
    }));
  };

  const handlePageChange = ({ selected }) => {
    setFilters((prevState) => ({
      ...prevState,
      page: selected,
    }));
  };
  const [removeReport, { isLoading: deleteloading }] = useDeleteReportMutation();

  const removeReports = (val) => {
    removeReport(val?.id, { skip: val.id })
      .unwrap()
      .then((res) => {
        toast.success(res?.message || 'Report deleted successfully');
        setDeleteModal(false);
        refetch();
      });
  };
  const [updateScheduleAReport] = useUpdateScheduleReportMutation();
  const handleSwitch = (flag, reportId) => {
    runIfAllowed(PERMISSIONS.MANAGE_REPORT_ANALYTICS, () => {
      setIsToggle(flag);
      updateScheduleAReport({ active: flag, id: reportId }).unwrap().then((res) => {
        toast.success(res?.message || 'Report updated successfully');
        refetch();
      });
    });
  };
 const [timer, setSearchTimer] = useState(null);
   const handleSearch = (evt) => {
    clearTimeout(timer);
    const query = evt.target.value;
    const newTimer = setTimeout(() => {
      setFilters({ ...filters, page: 0, query: query });
    }, 2000);
    setSearchTimer(newTimer);
  };

  const handleSort = (sort) => {
    setFilters((prevState) => ({
      ...prevState,
      sortedColumn: { ...sort },
    }));
  };

  if (!canManageReportAnalytics) {
    return (
      <div className="d-flex align-items-center justify-content-center p-5 min-vh-50">
        <div className="text-center">
          <h3 className="mb-3">Access denied</h3>
          <p className="text-muted mb-0">{PERMISSION_DENIED_MESSAGE}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div>
        <PortletWrapper>
          <PortletHeader
            tabs={[]}
            title={<StyledLabel size='32px' weight={'500'} font='Fredoka, sans-serif'>Schedule Reports</StyledLabel>}
            titleDetails={<StyledLabel size='14px' weight={'400'} font='Raleway, sans-serif'>Find scheduled reports here & schedule new report</StyledLabel>}
            labelClassName='pb-3'
            actions={
              <div className="flex-center pb-3">
                <StyledButton
                  onClick={() =>
                    runIfAllowed(PERMISSIONS.MANAGE_REPORT_ANALYTICS, () => {
                      window.location.href = '/schedule/reporting/creation';
                    })
                  }
                  className="btn btn-primary"
                  icon={<AddIcon />}
                  hidden={!canManageReportAnalytics}
                >
                  Create Schedule Report
                </StyledButton>
              </div>
            }
            search={<div className="flex-center mb-3">
                    <div className="flex-grow-1">
                      <StyledIconInput
                        icon={<SearchIcon />}
                        className="mw-50"
                        $maxWidth="50%"
                        $marginLeft="3px"
                        onChange={handleSearch}
                        loading={isFetching}
                        placeholder="Search report by Name"
                      />
                    </div>
                    </div>}
          />
          <div className="portlet__body-bg px-0">
            {isFetching ? (
              <div className='p-2'>
              <HiringRequestsListingSekeleton columns={columns} show={true} className='py-2 px-2' />
              </div>
            ) : (
             
              <PortletBody>
                           {reportingList?.data?.length > 0 ?
                           <> 
                <Table
                  data={reportingList?.data ?? []}
                  columns={columns}
                  onSort={handleSort}
                  sortColumn={filters.sortedColumn}
                  loading={true}
                />

                <PaginationPerPage
                  perPage={reportingList?.pagination?.perPage || LISTING_PER_PAGE}
                  pageNo={reportingList?.pagination?.page + 1 || 0}
                  onPerPageChange={handlePerPageChange}
                  totalCount={reportingList?.pagination?.total || 0}
                  onPageChange={handlePageChange}
                /></>
                :
                  <EmptyState
                    title="No Data"
                    description="There is currently no information to display."
                  />
                                    }
              </PortletBody>
            )}
          </div>
        </PortletWrapper>
      </div>
      {executionModal?.id && <ExecutionModal
          show={true}
          onHide={() => {
            setExecutionModal(false);
          }}
          data={executionModal}
        />   
    }
      {deleteModal?.id && <DeleteDepartmentModal
        show={true}
        onHide={() => {
          setDeleteModal(false);
        }}
        type={'report'}
        onSubmit={(val) => removeReports(val)}
        deleteloading={deleteloading}
        deleteDepartment={deleteModal}
        title={`Delete Report : ${deleteModal?.name}`}
        description={
          'Are you sure you want to delete this report? This action cannot be undone'
        }
      />
      }
    </>
  );
};
export default ReportingDashboard;

const PortletWrapper = styled(Portlet)`
  .portlet-header-subtitle,
  .portlet-header-title {
    font-weight: 400 !important;
    font-size: 32px !important;
    font-family: 'Fredoka', sans-serif;
  }
  .portlet__header-container {
    padding: 16px 24px 0px 24px !important;
  }
`;